import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DriverSubscriptionModel } from '../models/driver.model';
import { DriverService } from '../models/driver.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, IKeyValueInterface, ApplicationRouteURL, DataListModel } from '../../shared/config';

@Component({
  selector: 'wego-driver-subscription-list',
  template: require('../views/driversubscription-list.component.html'),
  styles: [`.clear-div {
    clear: both;
  } `],
  providers: [DriverService],

})
export class DriverSubscriptionListComponent implements OnInit {
  DataListModel: DataListModel;
  driverSubscriptionList: DriverSubscriptionModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  errorModel: IKeyValueInterface[];
  urlDefaultPage: string;
  private module: string
  private breadCrumbList: string;

  constructor(private driverService: DriverService,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblSubscription');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["sharedVehiclegroup", "subscriptionName", "timeInterval"];
    this.GetDriverSubscriptionList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetDriverSubscriptionList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetDriverSubscriptionList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetDriverSubscriptionList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetDriverSubscriptionList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.driverService.ExportDriverSubscriptionList(this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "Driver_Subscription" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }

  public GetDriverSubscriptionList() {
    this.isLoading = true;
    this.driverService.GetDriversSubscriptionDetail(this.DataListModel)
      .subscribe(
      res => {
        this.driverSubscriptionList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driver/components/driversubscription-list.component.ts